import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import Ripple from 'vuetify/lib/directives/ripple';

Vue.use(Vuetify, {
  directives: {
    Ripple,
  }
});

// import 'material-design-icons/iconfont/material-icons.css'
// import 'vuetify/dist/vuetify.min.css'

// Carrega o lang para o Vuetify
import pt from 'vuetify/es5/locale/pt'
import colors from 'vuetify/es5/util/colors'

const vuetifyConfig = {
  lang: {
    locales: { pt },
    current: 'pt',
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: colors.teal, //colors.blue.darken1, // '#3F51B5', //'#1976D2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
      dark: {
        primary: "#1565C0",
      },
    },
  },
}

export default new Vuetify(vuetifyConfig);